export const Permissions = {
    COMPANIES: 'companies',
    COMPANIES_ADD_COMPANY: 'companies.add_company',
    COMPANIES_DISABLE_USER_2FA: 'companies.disable_user_2fa',
    COMPANIES_DELETE_COMPANY: 'companies.delete_company',
    COMPANIES_MIGRATE: 'companies.migrate',
    COMPANIES_USERS: 'companies.users',
    COMPANIES_GROUPS: 'companies.groups',
    COMPANIES_DEVICES: 'companies.devices',
    COMPANIES_SHARES: 'companies.shares',
    COMPANIES_VAULTS: 'companies.vaults',
    COMPANIES_POLICIES: 'companies.policies',
    COMPANIES_BACKUPS: 'companies.backups',
    COMPANIES_CONNECTORS: 'companies.connectors',
    COMPANIES_PARTNER_USERS: 'companies.partner.users',
    COMPANIES_PARTNER_ROLES: 'companies.partner.roles',
    COMPANIES_PARTNER_COMPANY_GROUPS: 'companies.partner.company_groups',
    ACCOUNT_DETAILS: 'account.details',
    ACCOUNT_DETAILS_SUMMARY: 'account.details.summary',
    ACCOUNT_DETAILS_USER_COUNTS: 'account.details.user_counts',
    ACCOUNT_DETAILS_TRANSACTIONS: 'account.details.transactions',
    ACCOUNT_DETAILS_PAYMENT_METHOD: 'account.details.payment_method',
    ACCOUNT_DETAILS_PAYMENT_SETTINGS: 'account.details.settings',
    ACCOUNT_DETAILS_SUBSCRIPTION_USER: 'account.details.subscription_user',
    ACCOUNT_DETAILS_SUBSCRIPTION_OWNER: 'account.details.subscription_owner',
    ACCOUNT_MY_PROFILE: 'account.my_profile',
    RESOURCES: 'resources',
    REPORTS: 'reports',
    REPORTS_USER_ACTIVITY: 'reports.user_activity',
    REPORTS_EVENT_LOG: 'reports.event_log',
    REPORTS_PASSWORD_ACTIVITY: 'reports.password_activity',
    DASHBOARD: 'dashboard',
    INTEGRATIONS: 'integrations',
    SUBSCRIPTION: 'subscription',
    SUBSCRIPTION_USERS: 'subscription.users',
    SUBSCRIPTION_GROUPS: 'subscription.groups',
    SUBSCRIPTION_DEVICES: 'subscription.devices',
    SUBSCRIPTION_POLICIES: 'subscription.policies',
    SUBSCRIPTION_CONNECTORS: 'subscription.connectors',
    SUBSCRIPTION_BACKUPS: 'subscription.backups',
    SUBSCRIPTION_SETTINGS: 'subscription.settings',
};

export const Types = {
    VIEW: 'view',
    CHANGE: 'change',
};

export const Dependencies = [
    {
        permission: Permissions.COMPANIES_USERS,
        type: Types.VIEW,
        requires: [
            {
                permission: Permissions.COMPANIES,
                type: Types.VIEW,
            },
        ],
    },
    {
        permission: Permissions.COMPANIES_USERS,
        type: Types.CHANGE,
        requires: [
            {
                permission: Permissions.COMPANIES_GROUPS,
                type: Types.VIEW,
            },
        ],
    },
    {
        permission: Permissions.COMPANIES_GROUPS,
        type: Types.VIEW,
        requires: [
            {
                permission: Permissions.COMPANIES,
                type: Types.VIEW,
            },
        ],
    },
    {
        permission: Permissions.COMPANIES_GROUPS,
        type: Types.CHANGE,
        requires: [
            {
                permission: Permissions.COMPANIES_USERS,
                type: Types.VIEW,
            },
        ],
    },
    {
        permission: Permissions.COMPANIES_SHARES,
        type: Types.VIEW,
        requires: [
            {
                permission: Permissions.COMPANIES,
                type: Types.VIEW,
            },
        ],
    },
    {
        permission: Permissions.COMPANIES_POLICIES,
        type: Types.VIEW,
        requires: [
            {
                permission: Permissions.COMPANIES,
                type: Types.VIEW,
            },
        ],
    },
    {
        permission: Permissions.COMPANIES_BACKUPS,
        type: Types.VIEW,
        requires: [
            {
                permission: Permissions.COMPANIES,
                type: Types.VIEW,
            },
        ],
    },
    {
        permission: Permissions.COMPANIES_CONNECTORS,
        type: Types.VIEW,
        requires: [
            {
                permission: Permissions.COMPANIES,
                type: Types.VIEW,
            },
        ],
    },
    {
        permission: Permissions.COMPANIES_ADD_COMPANY,
        type: Types.VIEW,
        requires: [
            {
                permission: Permissions.COMPANIES,
                type: Types.VIEW,
            },
        ],
    },
    {
        permission: Permissions.COMPANIES_PARTNER_USERS,
        type: Types.VIEW,
        requires: [
            {
                permission: Permissions.COMPANIES_USERS,
                type: Types.VIEW,
            },
            {
                permission: Permissions.COMPANIES_PARTNER_ROLES,
                type: Types.VIEW,
            },
            {
                permission: Permissions.COMPANIES_PARTNER_COMPANY_GROUPS,
                type: Types.VIEW,
            },
        ],
    },
    {
        permission: Permissions.COMPANIES_DISABLE_USER_2FA,
        type: Types.VIEW,
        requires: [
            {
                permission: Permissions.COMPANIES_DISABLE_USER_2FA,
                type: Types.CHANGE,
            },
        ],
    },
    {
        permission: Permissions.COMPANIES_ADD_COMPANY,
        type: Types.VIEW,
        requires: [
            {
                permission: Permissions.COMPANIES_ADD_COMPANY,
                type: Types.CHANGE,
            },
        ],
    },
    {
        permission: Permissions.COMPANIES_DELETE_COMPANY,
        type: Types.VIEW,
        requires: [
            {
                permission: Permissions.COMPANIES_DELETE_COMPANY,
                type: Types.CHANGE,
            },
        ],
    },
    {
        permission: Permissions.SUBSCRIPTION_USERS,
        type: Types.VIEW,
        requires: [
            {
                permission: Permissions.SUBSCRIPTION,
                type: Types.VIEW,
            },
        ],
    },
];
